import { Box, Grid, TextField, Toolbar, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Dispatch } from "react";
import { premiumVoices } from '../assets/premiumVoices';
import StarsIcon from '@material-ui/icons/Stars';
import AudioPlayerComponent from './AudioPlayer';
import { StateInterface } from './state/reducer/store';
import { useDispatch, useSelector } from "react-redux";
import { StateAction } from './state/actions/actions';
import { theme } from '../assets/theme';
export default function PremiumVoiceDemo() {
    const selectedPremiumVoice = useSelector((state: StateInterface) => state.selectedPremiumDemoVoice);
    const premiumVoiceAutoplay = useSelector((state: StateInterface) => state.premiumVoiceAutoplay);
    const dispatch: Dispatch<StateAction> = useDispatch();
    const config = useSelector((state: StateInterface) => state.config);

    return (
        <Box style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
            <Box style={{ padding: 16 }}>

                <Toolbar
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 24,
                    }}
                >
                    <Grid container>
                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography
                                variant='inherit'
                                style={{ margin: '0 0 16px 0', fontSize: 24, color: theme.palette.background.paper }}

                            >
                                {config.textByLanguage['header.summary2']}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={2} style={{ display: 'flex', justifyContent: 'center' }}>
                        </Grid>

                        <Grid item xs={12} md={4} style={{ marginBottom: 24, display: 'flex', justifyContent: 'center' }}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={premiumVoices.sort((a, b) => {
                                    if (a.language[0] < b.language[0]) {
                                        return -1;
                                    } else if (a.language[0] > b.language[0]) {
                                        return 1;
                                    } else return 0
                                })}
                                onChange={(e, val) => {
                                    dispatch({ type: 'SET_PREMIUM_DEMO_VOICE', payload: val || null })
                                    dispatch({
                                        type: 'SET_PREMIUM_DEMO_VOICE_AUTOPLAY',
                                        payload: true
                                    })
                                }}

                                getOptionLabel={(option) => `${option.language} - ${option.humanName}`}
                                style={{ width: 300 }}
                                defaultValue={premiumVoices[45]}
                                getOptionSelected={(option, value) => option.name === value.name}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" style={{ backgroundColor: theme.palette.background.paper }} />
                                )}
                                groupBy={(option => option.language)}
                                renderOption={(option => {
                                    return <div style={{ display: 'flex', alignItems: 'center' }}>{`${option.language} - ${option.humanName}`} {option.name.includes("Wavenet") && < StarsIcon style={{ marginLeft: 8 }} />} </div>;
                                })}
                            />
                        </Grid>
                        <Grid item xs={12} md={5} style={{ marginBottom: 24, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <StarsIcon style={{ marginLeft: 24 }} />
                            <Typography
                                variant='body1'
                                style={{ color: theme.palette.background.paper }}
                            >
                                = {config.textByLanguage['header.neuralVoiceTechnology']}
                            </Typography>
                        </Grid>
                        <AudioPlayerComponent src={selectedPremiumVoice ? selectedPremiumVoice.url : ''} autoPlay={premiumVoiceAutoplay} />

                    </Grid>
                </Toolbar>

            </Box>
        </Box>
    )
}
